"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propNames = ['id', 'value', 'onChange', 'label', 'optional', 'validationError', 'themeControlSwitchContainer', 'themeControlSwitch', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

var ControlSwitch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ControlSwitch, _React$Component);

  function ControlSwitch() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ControlSwitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlSwitch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.checked, _this.props.id);
    });

    return _this;
  }

  _createClass(ControlSwitch, [{
    key: "render",
    value: function render() {
      var extraProps = (0, _omit.default)(this.props, propNames);
      var _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          label = _this$props.label,
          validationError = _this$props.validationError,
          themeControlSwitchContainer = _this$props.themeControlSwitchContainer,
          themeControlSwitch = _this$props.themeControlSwitch,
          themeControlWrapper = _this$props.themeControlWrapper,
          optional = _this$props.optional,
          themeLabel = _this$props.themeLabel; // value might be an empty string. Form will do this if no initialValue
      // is set.

      var checked = value === '' ? false : value;
      var inputProps = {
        id: id,
        checked: checked,
        onChange: this.onChange,
        type: 'checkbox',
        'data-test': "".concat(id, "-input")
      };

      if (validationError) {
        inputProps['aria-invalid'] = true;
      }

      return _react.default.createElement(_controlWrapper.default, {
        themeControlWrapper: themeControlWrapper,
        id: id,
        validationError: validationError
      }, _react.default.createElement("label", {
        className: "switch-container ".concat(themeControlSwitchContainer)
      }, _react.default.createElement("input", _extends({}, inputProps, extraProps)), _react.default.createElement("div", {
        className: "switch ".concat(themeControlSwitch)
      }), _react.default.createElement("span", {
        className: themeLabel
      }, label, optional && _react.default.createElement("span", {
        className: "ml3 txt-normal"
      }, "(optional)"))));
    }
  }]);

  return ControlSwitch;
}(_react.default.Component);

exports.default = ControlSwitch;

_defineProperty(ControlSwitch, "propTypes", {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** Input value */
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf([''])]),

  /** If provided the text, "(optional)" is appended to the value of the label element. */
  optional: _propTypes.default.bool,

  /** Called during changes to the input element. */
  onChange: _propTypes.default.func.isRequired,

  /** Value passed to the label element. */
  label: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the switch container */
  themeControlSwitchContainer: _propTypes.default.string,

  /** Assembly classes to apply to the switch element */
  themeControlSwitch: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Assembly classes to apply to the label element */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlSwitch, "defaultProps", {
  value: false,
  themeControlSwitchContainer: '',
  themeControlSwitch: 'switch--s-label',
  optional: false,
  themeLabel: 'txt-s ml6'
});